<template>
  <div class="mb-3 pb-3 mt-3 pt-3 px-4">
    <site-app-variant-form
      :app-variant="appVariant"
      :loading="loading"
      @update-internal-settings="
        (key: string, req: SiteInternalSettingsAppVariantEnum) =>
          emit('updateInternalSettings', key, req)
      "
    />
    <site-pins-config :pins="pins" @settings-update="emit('settingsUpdate')" />
    <h2>{{ t("components.siteSettings.features.title") }}</h2>
    <site-manual-limits-config
      :title="t('components.siteSettings.features.moto.label')"
      limit-key="moto"
      :limit="moto"
      :loading="loading"
      :country="country"
      @update-internal-settings="
        (key: string, req: SiteInternalSettingsMoto) => emit('updateInternalSettings', key, req)
      "
    />
    <site-manual-limits-config
      :title="t('components.siteSettings.features.unreferencedRefunds.label')"
      limit-key="unreferencedRefunds"
      :limit="unreferencedRefunds"
      :loading="loading"
      :country="country"
      @update-internal-settings="
        (key: string, req: SiteInternalSettingsMoto) => emit('updateInternalSettings', key, req)
      "
    />
  </div>
</template>

<script setup lang="ts">
import {
  SiteInternalSettingsPinsInner,
  SiteInternalSettingsMoto,
  SiteInternalSettingsAppVariantEnum,
} from "@tableyeti/merchant-service";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { pins, moto, appVariant } = defineProps<{
  pins?: Array<SiteInternalSettingsPinsInner>;
  unreferencedRefunds?: SiteInternalSettingsMoto;
  moto?: SiteInternalSettingsMoto;
  loading?: boolean;
  country: string;
  appVariant?: SiteInternalSettingsAppVariantEnum;
}>();

const emit = defineEmits<{
  updateInternalSettings: [string, SiteInternalSettingsMoto | SiteInternalSettingsAppVariantEnum];
  settingsUpdate: [];
}>();
</script>
